import React from 'react'
import PropTypes from 'prop-types'
import BillCard from './bill-card'

import { Grid } from 'semantic-ui-react'

const BillList = (props) => {
  const emptyMessage = <p>Fatura Bulunamadı</p>


  return (
    <div>
      {
        <Grid stackable columns={3}>
          {props.billList ? (
            props.billList.length === 0 ? (
              emptyMessage
            ) : (
              props.billList.map((bill) => (
                <Grid key={bill.invoiceNo} stackable columns={3}>
                  <BillCard
                    key={bill.invoiceNo}
                    invoice={bill}
                  >
                  </BillCard>
                </Grid>
              ))
            )
          ) : (
            <h1></h1>
          )}
        </Grid>
      }
    </div>
  )
}

// BillList.propTypes = {
//     billList : PropTypes.shape ({
//         invoiceList: PropTypes.array.isRequired
//     }).isRequired
// };

BillList.propTypes = {
  billList: PropTypes.array
}

export default BillList
